import React from 'react';
import { Image } from '@thd-olt-component-react/core-ui';
import proptypes from 'prop-types';
const { shape, bool: boolType } = proptypes;

const CollectionsImage = ({ metadata = {}, isMobile = false, showColUpLevel = false }) => {

  return (
    <div>
      {!showColUpLevel && !isMobile && metadata?.collectionImageUrl && (
        <div>
          <Image
            src={metadata?.collectionImageUrl}
            alt="main-product-image"
            height="300"
            width="300"
            data-testid="anchor-image"
            className="sui-w-full"
          />
        </div>
      )}

    </div>
  );
};

CollectionsImage.propTypes = {
  metadata: shape({
  }),
  isMobile: boolType,
  showColUpLevel: boolType
};

export default CollectionsImage;